import { Badge as BaseBadge } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';

export const Badge = ({
  variant,
  size,
  ...props
}: React.ComponentProps<typeof BaseBadge>) => {
  return (
    <BaseBadge
      className={cn({
        'bg-[#D9DFFD] text-[#374151]': variant === 'info',
        'bg-[#E5E7EB] text-[#374151]': variant === 'neutral',
        'bg-[#DCFCE7] text-[#374151]': variant === 'success',
        'text-base': size === 'lg',
      })}
      {...props}
      size={size}
      variant={variant}
    />
  );
};
